import api from '../api';

export class StorageService {
  async get(key) {
    return  await localStorage.getItem(this.formatAppStorageKey(key));
  }

  set(key, value) {
    if (value && value !== "null") {
      localStorage.setItem(this.formatAppStorageKey(key), value);
    }
  }

  remove(key) {
    localStorage.removeItem(this.formatAppStorageKey(key));
  }

  formatAppStorageKey(key) {
    return `clientApp.videoChat.${key}`;
  }
}
